export enum BonusTypesEnums {
  BUH = 'buh',
  BONUS = 'bonus',
  PAYMENT = 'payment',
  SLEEP_COMP = 'sleepcomp',
  AVAIL_COMP = 'availcomp',
  EXTRA_COMP = 'awa'
}
